import { render } from "./ViewAssetTemplate.vue?vue&type=template&id=0893945f&scoped=true"
import script from "./ViewAssetTemplate.vue?vue&type=script&lang=js"
export * from "./ViewAssetTemplate.vue?vue&type=script&lang=js"

import "./ViewAssetTemplate.vue?vue&type=style&index=0&id=0893945f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0893945f"]])

export default __exports__